import NotificationPreferences from './notification_preferences';

export {
  NotificationPreferences
};
